var render = function render(){var _vm=this,_c=_vm._self._c;return _c('editor',_vm._g({staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"editor","model-events":"change keydown blur focus paste","init":_vm.editorInit},on:{"onInit":_vm.onEditorInit},model:{value:(_vm.editorValue),callback:function ($$v) {_vm.editorValue=$$v},expression:"editorValue"}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }